import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
var listeners = {};
var initialized = false;
var onClickOutside = function onClickOutside(e) {
  _.forEach(listeners, function (listener) {
    if (!listener) {
      return;
    }
    var isClickInside = _.isElement(e.target) && listener.node.contains(e.target);
    if (!isClickInside) {
      listener.method(e);
    }
  });
};
var withClickOutside = function withClickOutside(Component) {
  var ClickOutside = /*#__PURE__*/function (_React$Component) {
    function ClickOutside(props) {
      var _this;
      _classCallCheck(this, ClickOutside);
      _this = _callSuper(this, ClickOutside, [props]);
      _this.callbacks = [];
      _this.registerOnClickOutside = function (method, node) {
        var id = _.uniqueId();
        _this.callbacks.push(_.assign({
          method: method,
          id: id
        }, node ? {
          node: node
        } : {}));
        return id;
      };
      _this.clearOnClickOutside = function (id) {
        _this.callbacks = _.reject(_this.callbacks, {
          id: id
        });
        delete listeners[id];
      };
      _this.createListeners = function () {
        var rootNode = ReactDOM.findDOMNode(_this);
        _.forEach(_this.callbacks, function (callback) {
          listeners[callback.id] = _.assign({
            node: rootNode
          }, callback);
        });
      };
      _this.initialize = function () {
        if (!initialized) {
          window.addEventListener('click', onClickOutside, true);
          initialized = true;
        }
      };
      return _this;
    }
    _inherits(ClickOutside, _React$Component);
    return _createClass(ClickOutside, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initialize();
        this.createListeners();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _.forEach(this.callbacks, function (callback) {
          delete listeners[callback.id];
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = _.assign({}, this.props, {
          onClickOutside: this.registerOnClickOutside,
          clearOnClickOutside: this.clearOnClickOutside
        });
        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);
  }(React.Component);
  return ClickOutside;
};
export default withClickOutside;